__turbopack_context__.v({
  "chip": "ConsoleFeature-module__SfKD4G__chip",
  "eyebrow": "ConsoleFeature-module__SfKD4G__eyebrow",
  "features": "ConsoleFeature-module__SfKD4G__features",
  "head": "ConsoleFeature-module__SfKD4G__head",
  "label": "ConsoleFeature-module__SfKD4G__label",
  "lead": "ConsoleFeature-module__SfKD4G__lead",
  "list": "ConsoleFeature-module__SfKD4G__list",
  "main": "ConsoleFeature-module__SfKD4G__main",
  "mirror": "ConsoleFeature-module__SfKD4G__mirror",
  "second": "ConsoleFeature-module__SfKD4G__second",
  "stage": "ConsoleFeature-module__SfKD4G__stage",
  "wrapper": "ConsoleFeature-module__SfKD4G__wrapper",
});
